import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from 'utils/request';
import { SEQUENCES_CUSTOM_FIELDS_KEY } from './useSequenceCustomFieldDefinitions';

function updateUserSequenceCustomField(
  customFieldId: string,
  body: {
    targets: string[];
  },
) {
  return request(`/user-sequences-custom-fields/${customFieldId}`, {
    method: 'PATCH',
    body,
  });
}

export const useUpdateUserSequenceCustomFieldDefinition = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      customFieldId,
      body,
    }: {
      customFieldId: string;
      body: { targets: string[] };
    }) => updateUserSequenceCustomField(customFieldId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SEQUENCES_CUSTOM_FIELDS_KEY],
      });
    },
  });
};
